var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAudioFileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 54,
    viewBox: "0 0 48 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8555 0.218506C30.1116 0.218506 32.2716 1.13165 33.8435 2.74995L45.6402 14.8946C47.1535 16.4526 48 18.539 48 20.711V46.1315C48 50.1656 44.7297 53.4359 40.6957 53.4359H7.30435C3.27027 53.4359 0 50.1656 0 46.1315V7.52285C0 3.48877 3.27027 0.218506 7.30435 0.218506H27.8555ZM27.8555 2.72285H7.30435C4.72702 2.72285 2.62412 4.75414 2.50929 7.30313L2.50435 7.52285V46.1315C2.50435 48.7089 4.53565 50.8118 7.08463 50.9266L7.30435 50.9316H40.6957C43.273 50.9316 45.3759 48.9003 45.4907 46.3513L45.4957 46.1315V20.711C45.4957 19.2857 44.9748 17.9129 44.0369 16.8483L43.8438 16.6395L32.0471 4.49486C31.0115 3.42869 29.6112 2.79977 28.1335 2.72947L27.8555 2.72285Z",
    fill: "#6238F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2321 41.9662C16.583 41.9662 18.486 40.0632 18.486 37.7123C18.486 35.3615 16.583 33.4585 14.2321 33.4585C11.8813 33.4585 9.97827 35.3615 9.97827 37.7123C9.97827 40.0632 11.9933 41.9662 14.2321 41.9662Z",
    stroke: "#6238F9",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0239 36.9289C33.3747 36.9289 35.2777 35.0258 35.2777 32.675C35.2777 30.3242 33.3747 28.4211 31.0239 28.4211C28.6731 28.4211 26.77 30.3242 26.77 32.675C26.77 35.0258 28.785 36.9289 31.0239 36.9289Z",
    stroke: "#6238F9",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4856 37.8243V23.4955C18.4856 22.0403 19.3811 20.8089 20.7245 20.3611L33.0383 16.8909C33.598 16.7789 34.0457 16.8909 34.4935 17.2267C34.9413 17.5625 35.1652 18.0103 35.1652 18.57V32.7868",
    stroke: "#6238F9",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4856 25.7342L35.2771 20.6968",
    stroke: "#6238F9",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioFileIcon);
export default __webpack_public_path__ + "static/media/audio-file-icon.d173f4e040250894a5ec1a6e2b9ac823.svg";
export { ForwardRef as ReactComponent };